<template>
  <div class="home">
    <div class="banner-box">
      <home-slide-one />
    </div>
    <div class="light-list">
      <div class="light-item">
        <div class="light-icon">
          <img src="../assets/light/01.png" alt />
        </div>
        <p class="light-title">融合的钉钉体验</p>
        <p class="light-content">实时同步钉钉各项数据</p>
        <p class="light-content">通讯录、考勤、Ding日程</p>
      </div>
      <div class="light-item">
        <div class="light-icon">
          <img src="../assets/light/02.png" alt />
        </div>
        <p class="light-title">功能全面</p>
        <p class="light-content">全方位满足成长型企业和组织</p>
        <p class="light-content">各类在线办公需求</p>
      </div>
        <div class="light-item">
        <div class="light-icon">
          <img src="../assets/light/04.png" alt />
        </div>
        <p class="light-title">极强的扩展性</p>
        <p class="light-content">依托蓝凌19年大客户经验</p>
        <p class="light-content">丰富的集成组件，应用灵活拓展</p>
      </div>
      <div class="light-item">
        <div class="light-icon">
          <img src="../assets/light/03.png" alt />
        </div>
        <p class="light-title">极佳的性价比</p>
        <p class="light-content">超低的价格实现</p>
        <p class="light-content">功能服务全场景覆盖</p>
      </div>

    </div>
    <div class="team">
      <div class="reason-title">
        <p class="reason-que">围绕着团队成员，全面解决日常办公需求</p>
        <p class="reason-desc">每天每件事情，实时推进目标成果，展开协作与管理，构建高效率协作团队</p>
      </div>
      <div class="team-list">
        <div class="team-imgwrap">
          <img
            name="fade"
            class="team-img animated fadeIn"
            :src="sideList[0]"
            alt
            v-show="activeIndex === 0 "
          />
          <img
            name="fade"
            class="team-img animated fadeIn"
            :src="sideList[1]"
            alt
            v-show="activeIndex === 1 "
          />
          <img
            name="fade"
            class="team-img animated fadeIn"
            :src="sideList[2]"
            alt
            v-show="activeIndex === 2 "
          />
          <img
            name="fade"
            class="team-img animated fadeIn"
            :src="sideList[3]"
            alt
            v-show="activeIndex === 3 "
          />
          <img
            name="fade"
            class="team-img animated fadeIn"
            :src="sideList[4]"
            alt
            v-show="activeIndex === 4 "
          />
          <img
            name="fade"
            class="team-img animated fadeIn"
            :src="sideList[5]"
            alt
            v-show="activeIndex === 5 "
          />
        </div>
        <ul class="team-detail point">
          <li
            :class="[activeIndex == index ? 'active' : '',]"
            v-for="(item,index) in teamList"
            :key="index"
            @mouseenter="mouseEnter(index)"
            @click="goproduct(index)"
          >
            <img :src="item.active" alt v-if="activeIndex == index" />
            <img :src="item.icon" alt v-else />
            <span>{{item.title}}</span>
            <p class="team-detail-item" v-if="activeIndex == index">
              <span v-for="(obj,i) in item.list" :key="i">{{obj}}</span>
            </p>
            <img
              src="../assets/decorate/1.png"
              alt
              class="fall-triangle"
              v-if="activeIndex == index"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="integrate">
      <div class="reason-title">
        <p class="reason-que">深度集成钉钉，让办公更智能高效</p>
        <p class="reason-desc">一键安装，基于钉钉的OA办公，打破时间和空间的限制，轻松高效完成工作任务</p>
      </div>
      <div class="integrate-banwrap">
        <div class="integrate-ban">
        <div>
          <img src="../assets/integrate/inte1.png" alt class="integrate-ban-img" />

                <div class="integrate-ban-content">
              <h3><p>自定义工作台</p><span>01</span></h3>
              <div class="integrate-content">深度集成钉钉，钉钉工作台企业个性化</div>
              <div class="integrate-content">随时随地移动办公</div>
              <div class="content-compan">
                <img src="../assets/integrate/icon5.png" alt />
                <span>企业个性化</span>
              </div>
            </div>
            </div>
        </div>
        <Integrate />
        <div class="integrate-tips point" @click="goHelp()">
          如何使用蓝凌智能OA
          <img src="../assets/arrows.png" alt />
        </div>
      </div>
    </div>
    <div class="common-box">
      <div class="reason">
        <div class="reason-title">
          <p class="reason-que">为什么选择蓝凌智能OA</p>
          <p class="reason-desc">SaaS一体化移动办公云平台，解决组织管理难题，为企业管理赋能</p>
        </div>
        <div class="reason-list">
          <div class="reason-item" v-for="(item,index) in reasonList" :key="index">
            <img :src="item.img" alt class="reason-item-icon" />
            <div class="reason-item-title">{{item.title}}</div>
            <div class="reason-item-content">{{item.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="enterprise">
      <div class="reason-title">
        <p class="reason-que">
          源自<span>10000+</span>知名企业的共同选择
        </p>
        <p class="reason-desc">成长型组织OA首选品牌</p>
      </div>
    </div>
    <div class="witness">
      <div class="pic left" @click="transCard(0)"></div>
      <div class="pic right" @click="transCard(1)"></div>

      <div class="picList">
    
        <div class="cardList" :style="'transform: translateX('+transLeft+'px)'">
          <div class="card" v-for="(item , index) in cardList" :key="index">
            <div><img :src="item.img" alt=""></div>
            <p>{{item.msg}}</p>
            <div class="yin"><img src="../assets/witness/yin.png" alt=""></div>
          </div>
        </div>
        <div class="mask"></div>
      </div>
    </div>

    <div class="enterprise-conpany">
      <img :src="item" alt v-for="(item,index) in companyList" :key="index" />
    </div>

  </div>
</template>
<script>
import CopyRight from "@/components/copyRight";
import Integrate from "@/components/integrate";
import HomeSlide from '@/components/home-slide'
import team1active from "../assets/team/1-active.png";
import team2active from "../assets/team/2-active.png";
import team3active from "../assets/team/3-active.png";
import team4active from "../assets/team/4-active.png";
import team5active from "../assets/team/5-active.png";
import team6active from "../assets/team/6-active.png";

import biglogo1 from "../assets/witness/biglogo-01.png";
import biglogo2 from "../assets/witness/biglogo-02.png";
import biglogo3 from "../assets/witness/biglogo-03.png";
import biglogo4 from "../assets/witness/biglogo-04.png";
import biglogo5 from "../assets/witness/biglogo-05.png";

import team1 from "../assets/team/1.png";
import team2 from "../assets/team/2.png";
import team3 from "../assets/team/3.png";
import team4 from "../assets/team/4.png";
import team5 from "../assets/team/5.png";
import team6 from "../assets/team/6.png";
// 为什么选择图片
import time from "../assets/time.png";
import meeting from "../assets/meeting.png";
import property from "../assets/property.png";
import mangement from "../assets/mangement.png";
import culture from "../assets/culture.png";
import key from "../assets/key.png";
import { companyList } from "../datas.js";
import { sideList } from "../datas.js";
import HomeSlideOne from '../components/home-slide-one'


export default {
  data() {
    return {
      activeIndex: 0,
      teamList: [
        {
          title: "客户在线",
          icon: team1,
          active: team1active,
          list: ["客户档案", "商机跟踪", "合同管理"]
        },
        {
          title: "团队协作",
          icon: team2,
          active: team2active,
          list: ["知识中心", "日程安排", "任务管理"]
        },
        {
          title: "日常办公",
          icon: team3,
          active: team3active,
          list: ["审批流程", "工作总结", "考勤打卡"]
        },
        {
          title: "人事在线",
          icon: team5,
          active: team5active,
          list: ["人事档案", "人员招聘", "人事流程"]
        },
        {
          title: "企业文化",
          icon: team6,
          active: team6active,

          list: ["网上调查", "员工黄页", "员工活动"]
        },
        {
          title: "行政管理",
          icon: team4,
          active: team4active,
          list: ["固资管理", "办公资源管理", "办公用品管理"]
        }
      ],
      reasonList: [
        {
          title: "即时沟通",
          img: time,
          content: "在移动设备上随时随地利用碎片化时间，组织24小时运行"
        },
        {
          title: "实时协作",
          img: meeting,
          content:
            "各岗位可基于具体工作目标点或事项快速部门之间无区域限制的通力协作"
        },
        {
          title: "工作留痕",
          img: property,
          content:
            "积累每天每人每事的过程，并自动汇报、沉淀和形成内部长期可用的经验分享"
        },
        {
          title: "提升执行力",
          img: mangement,
          content:
            "可建立从目标计划、到执行反馈、定期检查、以及完成总结分享的闭环工作机制"
        },
        {
          title: "文化传播",
          img: culture,
          content:
            "知识仓库、员工活动、投票调研等让组织更加柔性，让企业文化润物细无声"
        },
        {
          title: "多平台集成",
          img: key,
          content:
            "集成平台可以让ERP等业务管理软件与OA无缝集成，在OA中完成所有事项处理和信息数据查阅"
        }
      ],
      companyList: companyList,
      sideList: sideList,
      showBoxShadow: false,
      cardList:[
        {
          img:biglogo1,
          msg:'蓝凌智能OA能有效打通公司的流程架构和表单流程，极大程度提升了办公效率。定制化的功能非常完整的支撑了公司协同。目前员工都能集中在门户中查看各类信息，实现了办公的无纸化。'
        },
        {
          img:biglogo2,
          msg:'蓝凌智能OA和钉钉得到了完美的融合，蓝凌智能OA的知识管理及积分整体体系化功能弥补了单一钉钉办公在线学习的缺失。钉钉内的DING日程与蓝凌智能OA打通。实现了完整的人事功能模块。'
        },
        {
          img:biglogo3,
          msg:'天骄航空是一家年轻的公司，成长迅速，人员规模成长得也很快。用过蓝凌智能OA来搭建完整的人事流程，极大方便了人才的“招、培、管、用“。DING信息与流程，让公司的协作效率提升80%以上！'
        },
        {
          img:biglogo4,
          msg:'作为美妆新零售企业，我们的门店、品牌扩充、组织构成正在日益复杂。业务的管控难度也随之加大。蓝凌智能OA让我们的开店、订货、销售等83个业务类别得到有机的统一管理，加快了这些业务的流程效率。业务与管理融合度更高，企业自然发展得更快更好！'
        },
        {
          img:biglogo5,
          msg:'淳百味餐饮是专注沙县小吃食品研发加工、连锁店运营的品牌。近年来跨区域发展较快。基于蓝凌智能OA推动企业流程的提速，费用可控效果显著。在知识管理功能的帮助下，企业3000+员工的成长也得到了前所未有的加速。相信在蓝凌智能OA的帮助下，我们“百城万店”的计划很快就能成功落地。'
        },
      ],
      transLeft:0,
      isShowLogin:false,
      errMessage:'',
      tel:"",               //用户数据
      code:'',
      username:"",
      company:"",
      useremail:"",
      loginWay:1,         //登录方式
      errTel:'',          //错误信息
      errName:'',
      errComp:'',
      errCode:'',
      codeTime:0,
      toast:'',
      lwfrom:'0'
    };
  },
  components: { CopyRight, Integrate, HomeSlideOne },
  created() {
    this.$root.$on('change',(val)=>{
        this.isShowLogin = val
    })
    //获取lwfrom
    var reg = new RegExp("(^|&)lwfrom=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r){
      this.lwfrom = r[2];
    }
  },
  methods: {
    showLogin(){
      this.$root.$emit('change',true)
    },
    transCard(i){
      if(i){
        this.transLeft > (-3*460) ? this.transLeft -= 460:null
      }else{
        this.transLeft<0?this.transLeft += 460:null;
      }
    },
    mouseEnter(index) {
      this.activeIndex = index;
    },
    goproduct(index) {
        this.$router.push({
          path :"/product",
          query:{
            title : this.teamList[index].title
          }
        })
    },
    setDotted(type) {
      if (type == 1) {
        _czc.push(["_trackEvent", "banner_按钮_立即体验", "button"]);
      }
      if (type == 2) {
        _czc.push(["_trackEvent", "立即体验", "button"]);
      }
    },
    goHelp() {
      _czc.push(["_trackEvent","如何使用蓝凌智能OA", "button"]);
      this.$router.push("/help");
    }
  }
};
</script>

<style lang="less">
.home {
  margin-bottom: 120px;
}
.banner-box {
  width: 100%;
  background: url("../assets/banner-bg2.png") 0 0 no-repeat;
  background-size: cover;
  height: 520px;
  box-shadow: 0 31px 30px 0px rgba(217, 223, 236, 0.2);
  padding-top: 70px;
  box-sizing: border-box;
}

.shadow-cion {
  position: absolute;
  top: 5px;
  left: -5px;
  width: 150px;
}
.reason {
  background-size: 287px 175px;
  .reason-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 50px;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .reason-item {
    width: 288px;
    text-align: center;
    display: inline-block;
    padding: 50px 32px;
    width: 30%;
    &:hover {
      background: #ffffff;
      box-shadow: 0 2px 10px 0 rgba(217, 223, 236, 0.8);
      border-radius: 10px;
    }
    .reason-item-icon {
      width: 64px;
      height: 64px;
    }
    .reason-item-title {
      font-size: 20px;
      color: #333333;
      text-align: center;
      line-height: 24px;
      margin-bottom: 20px;
    }
    .reason-item-content {
      font-size: 16px;
      color: #999999;
      line-height: 22px;
    }
  }
}
.reason-title {
  .reason-que {
    font-size: 24px;
    color: #333333;
    text-align: center;
    line-height: 24px;
    margin-bottom: 14px;
  }
  .reason-desc {
    font-size: 16px;
    color: #666666;
    text-align: center;
    line-height: 16px;
  }
}
.enterprise {
  width: 1200px;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;

}
.enterprise-conpany {
  width: 1200px;
  margin: 0 auto;
  margin-top: 100px;
  img {
    width: 166px;
  }
}

.light-list {
  width: 1130px;
  background: #ffffff;
  box-shadow: 0 2px 10px 0 rgba(217, 223, 236, 0.5);
  border-radius: 10px;
  padding: 30px 92px 33px;
  margin: 0 auto;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  .light-item {
    width: auto;
    .light-icon {
      img {
        width: 45px;
        height: 45px;
      }
    }
    .light-title {
      font-size: 18px;
      color: #333333;
      line-height: 24px;
      margin-top: 20px;
      padding-bottom: 4px;
    }
    .light-content {
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      padding-top: 6px;
    }
  }
}
.team {
  margin-top: 120px;
  .team-list {
    min-width: 1200px;
    display: flex;
    align-items: top;
    margin-top: 91px;
    .team-imgwrap {
      background: #fafbfc;
      width: calc(
        50% + 110px
      ); //calc (100%-有效宽度) + 图片宽度  左侧背景图片宽度
      min-width: 710px;
      text-align: right;
      .team-img {
        width: 710px;
      }
    }
    ul {
      display: inline-block;
      padding-top: 30px;
      padding-bottom: 10px;
      width: 450px;
      font-weight: normal;
      margin-left: 40px;
      li {
        margin-bottom: 40px;
        padding-left: 36px;
        text-align: left;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 16px;
        vertical-align: middle;
      }
    }
    .team-detail {
      span {
        font-size: 20px;
      }
    }
    .team-detail-item {
      padding-left: 45px;
      margin-top: 10px;
      span {
        margin-right: 20px;
        font-size: 16px;
      }
    }
    .active {
      padding-top: 10px;
      background: linear-gradient(
        -179deg,
        #e7f1ff 0%,
        rgba(222, 233, 255, 0) 81%
      );
      background: -moz-linear-gradient(
        -179deg,
        #e7f1ff 0%,
        rgba(222, 233, 255, 0) 81%
      );
      background: -webkit-linear-gradient(
        -179deg,
        #e7f1ff 0%,
        rgba(222, 233, 255, 0) 81%
      );
      background: -o-linear-gradient(
        -179deg,
        #e7f1ff 0%,
        rgba(222, 233, 255, 0) 81%
      );
      background: -ms-linear-gradient(
        -179deg,
        #e7f1ff 0%,
        rgba(222, 233, 255, 0) 81%
      );
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e7f1ff', endColorstr='#ffffff',GradientType=0 );
      background-size: 150px;
      background-repeat: no-repeat;
      position: relative;
      height: 70px;
      overflow: hidden;
      &:after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 8px solid rgba(241, 246, 254);
        position: absolute;
        left: -8px;
        top: 12px;
      }
      &:before {
        content: "更多";
        display: block;
        position: absolute;
        right: 10px;
        color: #4285f4;
        font-size: 14px;
        background: url("../assets/decorate/arrows.png") right center no-repeat;
        background-size: 15px;
        width: 50px;
        z-index: 8;
      }
      > span {
        color: #4285f4;
        font-size: 20px;
      }
    }
  }
  .fall-triangle {
    width: 150px !important;
    height: auto !important;
    position: absolute;
    right: -20px;
    top: 0px;
  }
}
.integrate {
  margin-top: 120px;
  margin-bottom: 120px;
  padding-top:95px;
  background: #fafbfc;
  
  .reason-title {
    padding-bottom: 120px;
  }
  .integrate-banwrap {
    position: relative;

  }
  .integrate-ban {
    // background-image: linear-gradient(35deg, #4285f4 0%, #91baff 100%);
    // border-radius: 18px;
    // height: 230px;
    width: 1040px;
    margin:0 auto; 
    // position: absolute;
    // top: -128px;
    // left: 50%;
    // transform: translateX(-50%);
    >div{
      // width:100%;
      // padding-left: 632px;
      display: flex;
      align-items: center;
    }
    .integrate-ban-content {
        // padding-top: 53px;
        // padding-bottom: 30px;
        padding-left: 123px;
    }
  }
  .integrate-ban-img {
    width: 520px;
    height: 400px;
    // position: absolute;
    // bottom: 0;
    // left: 0%;
    // z-index: 10;
  }
  .integrate-ban-imgwrap {
    width: 1040px;
    height: 230px;
    margin: 0 auto;
    color: white;
    position: absolute;
    left: 50%;
    top: -128px;
    transform: translateX(-50%);
    z-index: 5;
  }
  .integrate-tips {
    font-size: 16px;
    color: #4285f4;
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    padding-top: 103px;
    padding-bottom: 40px;
    box-shadow: 0 -10px 10px 22px rgba(250, 251, 254, 0.4);
    background: rgba(250, 251, 254);
    img {
      width: 7px;
      margin-left: 11px;
    }
  }
  > div {
    h3 {
      position: relative;
      margin-bottom: 14px;
      font-size: 28px;
      font-weight: normal;
      z-index: 10;
      >p{
        position: relative;
        z-index: 10;
        color: #333333;
      }
      >span {
        position: absolute;
        font-size: 60px;
        text-align: center;
        line-height: 50px;
        left: 0;
        top: -30px;
        color: #ebebeb;
        z-index: 9;
      }
    }
    .integrate-content {
      line-height: 22px;
      font-size: 16px;
      color: #666;
    }
    .content-compan {
      margin-top: 30px;
      font-size: 14px;
      color: #999999;
      display: inline-block;
      margin-right:60px;
      img {
        width: 20px;
        height: 20px;
        vertical-align: text-bottom;
      }
    }
    .integrate-use {
      background: #ffffff;
      border-radius: 14px;
      width: 78px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      font-size: 14px;
      color: #4285f4;
      text-align: center;
      margin-top: 30px;
    }
  }
}
@media screen and (max-width: 1440px) and (max-height: 900px) {
  // .banner-box {
  //   height: 450px;
  // }
  // .banner {
  //   height: 450px;
  //   .banner-left {
  //     padding-top: 60px;
  //   }
  //   .banner-right {
  //     padding-top:30px;
  //     width: 500px;
  //     margin-left: 110px;
  //   }
  // }
  .light-list {
    margin-top: 30px;
    padding-top: 15px;
  }
  .team {
    margin-top: 60px;
  }
}
.closeIcon{
  width: 18px;
  height: 18px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
    span{
      display: inline-block;
      width: 18px;
      height: 1.5px;
      background-color: #666666;
      position: absolute;
      top: 8px;
      left: 0px;
      &:nth-child(1){
        transform: rotate(45deg)
      }
      &:nth-child(2){
        transform: rotate(-45deg)
      }
    }
    &:hover{
      span{
        height: 2px;
      }
    };
}
.witness{
  position: relative;
  width: 1300px;
  margin: 0 auto;

  .pic{
    width: 50px;
    height: 50px;
    transition: all 0.5s ;
    -webkit-transition: all 0.5s;
    position: absolute;
    top: 95px;
    cursor: pointer;
  }
  .left{
    left: 0;
    background: url('../assets/witness/left.png');
    background-size: cover;
    background-repeat: no-repeat;
    &:hover{
      background: url('../assets/witness/leftActive.png');
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  .right{
    right: 0;
    background: url('../assets/witness/right.png');
    background-size: cover;
    background-repeat: no-repeat;
    &:hover{
      background: url('../assets/witness/rightActive.png');
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  .picList{
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    .cardList{
      width: 2400px;
      display: flex;
      height: 300px;
      padding-top: 30px;
      padding-left: 30px;
      transition: all 0.5s;
    }
    .card{
      width: 430px;
      height: 240px;
      background: #FFFFFF;
      box-shadow: 0 0 30px 0 rgba(190,209,255,0.50);
      border-radius: 10px;
      margin-right: 30px;
      position: relative;
      padding:10px 30px;
      p{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #999999;
        letter-spacing: 0;
        line-height: 24px;
      }
      .yin{
        position: absolute;
        right: 30px;
        bottom: 15px;
      }
    }
    .mask{
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 100px;
      background-image: linear-gradient(to right, transparent , #ffffff);
    }
  }

}

</style>


// WEBPACK FOOTER //
// src/pages/home.vue